import React from 'react'
import { KTCard, KTCardBody } from '../../../../../../../_metronic/helpers'

const ActivityTab: React.FC = () => {
  return (
    <KTCard>
      <div className='card-header px-5'>
        <h3 className='card-title'>User Activity Log's</h3>
      </div>
      <KTCardBody className='p-0'>
        {/* Code for allow chats */}
        <div className='card-content d-flex justify-content-between align-items-center p-5 border-bottom'>
          <div className='d-flex align-items-center gap-4'>
            <div className='position-relative w-50px h-50px'>
              <svg className="w-100 h-100 stroke-input" width="44" height="48" viewBox="0 0 44 48" fill="#FAFAFA" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 2.4641C19.7128 0.320509 24.2872 0.320508 28 2.4641L37.6506 8.0359C41.3634 10.1795 43.6506 14.141 43.6506 18.4282V29.5718C43.6506 33.859 41.3634 37.8205 37.6506 39.9641L28 45.5359C24.2872 47.6795 19.7128 47.6795 16 45.5359L6.34937 39.9641C2.63655 37.8205 0.349365 33.859 0.349365 29.5718V18.4282C0.349365 14.141 2.63655 10.1795 6.34937 8.0359L16 2.4641Z" fill=""></path>
                <path d="M16.25 2.89711C19.8081 0.842838 24.1919 0.842837 27.75 2.89711L37.4006 8.46891C40.9587 10.5232 43.1506 14.3196 43.1506 18.4282V29.5718C43.1506 33.6804 40.9587 37.4768 37.4006 39.5311L27.75 45.1029C24.1919 47.1572 19.8081 47.1572 16.25 45.1029L6.59937 39.5311C3.04125 37.4768 0.849365 33.6803 0.849365 29.5718V18.4282C0.849365 14.3196 3.04125 10.5232 6.59937 8.46891L16.25 2.89711Z" stroke=""></path>
              </svg>
              <div className='icon-small-content'>
                <svg className="text-settings-icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fillRule="evenodd" d="M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-6.616l-2.88 2.592C8.537 20.461 7 19.776 7 18.477V17H5a2 2 0 0 1-2-2V6Zm4 2a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2H7Zm8 0a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm-8 3a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H7Zm5 0a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2h-5Z" clipRule="evenodd" />
                </svg>

              </div>
            </div>
            <div className='content-user-settings'>
              <h5 className='mb-1 fw-medium'>Allow Chats</h5>
              <span className='text-settings-icon'>Enable or disable chat functionality</span>
            </div>
          </div>
          <div className='form-check form-switch'>
            <input className='form-check-input' type='checkbox' id='allowChats' />
            <label className='form-check-label' htmlFor='allowChats'></label>
          </div>
        </div>
      </KTCardBody>
    </KTCard>
  )
}

export default ActivityTab
